// Central content + brand constants for HoneyBee Roofers.
// Update phone/email below with the client's real contact details.

export const COMPANY = {
  name: "Honey Bee Roofing & Exteriors",
  shortName: "HoneyBee Roofers",
  // TODO: replace with the client's real phone number
  phone: "(425) 275-1298",
  phoneRaw: "+14252751298",
  email: "hello@honeybeeroofers.com",
  address: {
    street: "118 SE Everett Mall Way",
    city: "Everett",
    state: "WA",
    zip: "98208",
  },
  areasShort: "Snohomish County • King County • Skagit County • Based in Everett, WA",
  base: "Everett, WA",
  guarantee: "50-Year CertainTeed Guarantee",
  hours: "Mon–Sat: 7am – 7pm",
  license: "WA Lic. #HONEYBE762PG",
  // TODO: replace with the client's exact Google Business Profile review link (g.page/r/...)
  googleReviewUrl: "https://www.google.com/maps/search/Honey+Bee+Roofing+%26+Exteriors+Lynnwood+WA",
};

export const IMAGES = {
  hero: "https://images.pexels.com/photos/15369780/pexels-photo-15369780.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  roofReplacement: "https://images.unsplash.com/photo-1726589004565-bedfba94d3a2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  roofRepair: "https://images.unsplash.com/photo-1632759145351-1d592919f522?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  shingles: "https://images.unsplash.com/photo-1635424709845-3a85ad5e1f5e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  storm: "https://images.pexels.com/photos/36237047/pexels-photo-36237047.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  inspection: "https://images.unsplash.com/photo-1633759593085-1eaeb724fc88?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  siding: "https://images.pexels.com/photos/15369767/pexels-photo-15369767.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  exterior: "https://images.unsplash.com/photo-1729796515115-354943ecd491?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  trust: "https://images.unsplash.com/photo-1635424709845-3a85ad5e1f5e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};

export const SERVICES = [
  {
    id: "roof-replacement",
    title: "Residential Roof Replacement",
    blurb:
      "Complete residential roof installation in Snohomish County backed by a 50-year CertainTeed guarantee. Flat-rate pricing, no surprises.",
    keywords: "roof replacement Everett WA, new roof installation Snohomish County, roof replacement cost Arlington WA",
    image: "roofReplacement",
    featured: true,
    icon: "Home",
  },
  {
    id: "storm-damage",
    title: "Storm Damage Repair",
    blurb:
      "Wind, rain & hail damage restored fast. We document everything and help with your roof damage insurance claim.",
    keywords: "storm damage roof repair Everett, roof damage insurance claim help Snohomish County",
    image: "storm",
    featured: true,
    icon: "CloudLightning",
  },
  {
    id: "commercial-roofing",
    title: "Commercial Roofing",
    blurb:
      "Our new commercial division: TPO, EPDM, PVC, modified bitumen, standing-seam metal & roof coatings for warehouses, retail, office, multi-family & churches.",
    keywords: "commercial roofing contractor Everett WA, TPO roofing Snohomish County, flat roof replacement Marysville WA, commercial roofer Arlington WA",
    image: "roofRepair",
    featured: true,
    icon: "Building2",
    to: "/commercial-roofing",
  },
  {
    id: "roof-repair",
    title: "Roof Leak & Repair",
    blurb:
      "From flashing to flat roofs, we fix leaks at the source. Honest diagnosis, durable repairs, fair pricing.",
    keywords: "roof repair Everett WA, roof leak repair Snohomish County, roof flashing repair Marysville, flat roof repair Everett",
    image: "roofRepair",
    featured: false,
    icon: "Wrench",
  },
  {
    id: "roof-inspection",
    title: "Roof Inspection",
    blurb:
      "Free, thorough in-home roof inspection with a clear written report and fixed, no-hassle pricing.",
    keywords: "roof inspection Everett WA, roof maintenance services Snohomish County, roofing estimates Arlington WA",
    image: "inspection",
    featured: false,
    icon: "ClipboardCheck",
  },
  {
    id: "siding-windows",
    title: "Siding & Windows",
    blurb:
      "High-quality siding and energy-efficient windows that protect and elevate your Pacific Northwest home.",
    keywords: "siding contractor Snohomish County, window replacement Arlington WA, exterior siding Everett",
    image: "siding",
    featured: false,
    icon: "PanelsTopLeft",
  },
  {
    id: "decks",
    title: "Decks & Outdoor Living",
    blurb:
      "Custom decks and outdoor living spaces, built to extend your home and stand up to the wet Northwest climate. From new builds to deck repairs and resurfacing.",
    keywords: "deck builder Snohomish County, deck installation Arlington WA, deck contractor Everett, outdoor living deck Marysville",
    image: "exterior",
    featured: false,
    icon: "Hammer",
  },
];

export const WHY = [
  {
    title: "Flat-Rate Pricing",
    body: "What you see is what you get. A fixed, transparent price up front — no hidden fees, no surprise charges after work begins.",
    icon: "Tag",
  },
  {
    title: "Integrity & Follow-Through",
    body: "We show up on time, keep our word, and do the right thing even when no one is watching. Every commitment, honored.",
    icon: "ShieldCheck",
  },
  {
    title: "Locally Owned in WA",
    body: "We live, work, and raise our families right here. We understand Pacific Northwest weather and treat your home like our own.",
    icon: "MapPin",
  },
  {
    title: "Backed by CertainTeed",
    body: "A partnership with one of roofing's most trusted names means top-tier materials and a 50-year guarantee on your shingles.",
    icon: "Award",
  },
];

export const STATS = [
  { value: "50yr", label: "CertainTeed Guarantee" },
  { value: "5.0", label: "Google Review Rating" },
  { value: "$0", label: "In-Home Evaluation" },
  { value: "100%", label: "Flat-Rate Transparency" },
];

export const SERVICE_AREAS = [
  "Arlington, WA", "Marysville", "Everett", "Lake Stevens", "Snohomish",
  "Monroe", "Sultan", "Stanwood", "Smokey Point", "Granite Falls",
  "Lynnwood", "Edmonds", "Mukilteo", "Bothell", "Seattle",
  "Bellevue", "Redmond", "Kirkland", "Mount Vernon", "Burlington",
  "Sedro-Woolley", "Skagit County",
];

export const TESTIMONIALS = [
  {
    name: "Carter F.",
    city: "Verified Google Review",
    text:
      "HoneyBee did a new roof on my house, shop, and new addition — about 37 squares. New facia, flashing, and a skylight, all completed in 5 days. They cleaned up well every day and even ran a magnet around the buildings for loose nails. Top-notch work and the roof looks beautiful.",
    rating: 5,
  },
  {
    name: "J M.",
    city: "Verified Customer",
    text:
      "Very easy to work with, honest and upfront about everything regarding time and price. They had my roof replaced in 4 days with no mess left behind. Extremely satisfied with the customer service and the job — highly recommend!",
    rating: 5,
  },
  {
    name: "Tami H.",
    city: "Verified Google Review",
    text:
      "As pleasant as a roof replacement can be! The price was very competitive, the customer service excellent, and the workers professional and hard working. My new roof looks wonderful and really compliments the stonework on the house.",
    rating: 5,
  },
  {
    name: "Brad C.",
    city: "Verified Google Review",
    text:
      "An outstanding job from inspection and insurance assistance through job completion. The crew was excellent and courteous and did great work. Would recommend to everyone who needs roof or fence work done.",
    rating: 5,
  },
  {
    name: "Alan S.",
    city: "Verified Google Review",
    text:
      "Fantastic, timely job installing my roof. They were conscious about the work area, cleaned up thoroughly, and hauled away all debris and nails. I give them 10 stars, not 5 — well worth it!",
    rating: 5,
  },
  {
    name: "Chris R.",
    city: "Verified Customer",
    text:
      "Work done quickly and well. When they found a leak during removal, they called immediately with options. When I asked about a different solution, they agreed and took care of it the same day. Highly recommended.",
    rating: 5,
  },
];

export const FAQS = [
  {
    q: "How much does a new roof cost in Snohomish County, WA?",
    a: "Most residential roof replacements in the Snohomish County and greater Puget Sound area range based on roof size, pitch, and material. Because we use flat-rate pricing, you'll get one fixed, written number after your free in-home evaluation — no estimates that balloon later. Financing options are available.",
  },
  {
    q: "Do you offer commercial roofing near me?",
    a: "Yes — our commercial roofing division installs and services flat and low-slope systems (TPO, EPDM, PVC, modified bitumen, standing-seam metal, and roof coatings) for warehouses, retail, office, multi-family, and church buildings across Snohomish, King, and Skagit County.",
  },
  {
    q: "Are you a licensed roofing contractor in Washington?",
    a: "Yes — Honey Bee Roofing & Exteriors is a locally owned, licensed and insured roofing contractor based in Everett, WA, serving Snohomish County, King County and Skagit County, and we're a CertainTeed-backed installer.",
  },
  {
    q: "Can you help with a roof damage insurance claim?",
    a: "Absolutely. We document storm and wind damage thoroughly, provide the reports your insurer needs, and guide you through the claim process so you get the coverage you're entitled to.",
  },
  {
    q: "What roofing materials do you install?",
    a: "We specialize in CertainTeed asphalt shingle roofing for residential homes, plus commercial flat and low-slope systems, flashing, ventilation, and gutters. Ask about eco-friendly roofing options for the Pacific Northwest.",
  },
  {
    q: "Do you serve my area?",
    a: "Based in Everett, WA, we proudly serve all of Snohomish County, King County and Skagit County — including Everett, Marysville, Arlington, Lake Stevens, Snohomish, Monroe, Stanwood, Mount Vernon, Burlington, Seattle, Bellevue and more.",
  },
  {
    q: "How long does a roof replacement take?",
    a: "Most residential roof replacements are completed in 1–3 days depending on size, complexity, and weather. We give you a clear timeline up front and keep you updated throughout.",
  },
  {
    q: "Do you offer financing for roof replacement?",
    a: "Yes, we offer roof repair and replacement financing so you can protect your home now and pay over time. Ask us during your free evaluation.",
  },
];

export const FORMSPREE_URL = "https://formspree.io/f/xjgnllnk";

export const SERVICE_OPTIONS = [
  "Residential Roof Replacement",
  "Commercial Roofing",
  "Storm Damage Repair",
  "Roof Leak / Repair",
  "Free Roof Inspection",
  "Siding / Windows",
  "Decks / Outdoor Living",
  "Other / Not Sure",
];
